import { faStar } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";

export default function Reviews () {
  return (
    <section className="relative mx-auto py-4 bigscreen-responsive gap-8">
      <div className="hidden xl:block absolute bottom-4 left-0 w-[900px] h-[200px] bg-gradient-to-r from-[#FBA919] to-transparent opacity-10 rounded-[120px] filter blur-md z-0"/>
      <div className="hidden xl:block absolute bottom-4 right-0 w-[900px] h-[200px] bg-gradient-to-l from-[#FBA919] to-transparent opacity-10 rounded-[120px] filter blur-md z-0"/>
      <div className="relative z-10 text-center text-lg">
        <h2 className="text-orange font-bold mb-8 px-6 py-2 uppercase">Testimoniales</h2>
        <h3 className="font-bold md:text-4xl">La mejor tasa de satisfacción en graduados</h3>
        <div className="flex justify-center">
          <p className="text-center text-[#637381] text-sm max-w-sm px-8 py-4 md:text-md md:max-w-lg md:px-0">Distintos estudiantes opinan sobre su experiencia con la educación recibida en Amura Centro Culinario.</p>
        </div>
        <div className="flex flex-col justify-center items-center text-left px-8 py-8 gap-16 xl:flex-row xl:justify-between xl:px-0">
          <div className="rounded-xl border border-[#FBF0E3] bg-white shadow-lg py-4 px-8 max-w-xs md:max-w-sm">
            <div className="flex gap-1 text-yellow">
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
            </div>
            <p className="text-sm text-[#637381] py-4 max-w-xs">“Estudiar en Amura fue una de las mejores decisiones de mi vida. La calidad de los profesores y el enfoque práctico del programa me permitieron desarrollar habilidades culinarias que nunca imaginé”</p> 
            <div className="flex items-center gap-4 py-4">
              <div className="h-12 w-12 overflow-hidden rounded-full relative">
              <Image src="/images/testimonials/dilan.jpeg" alt="Reviewer" width={48} height={48} className="h-12 w-12 object-cover" sizes="48px" />
              </div>
              <div>
                <p className="font-bold text-sm">Dilan Esquivel</p>
                <p className="font-thin text-xs">Graduado</p>
              </div>
            </div>
          </div>
          <div className="rounded-xl border border-[#FBF0E3] bg-white shadow-lg py-4 px-8 max-w-xs md:max-w-sm">
            <div className="flex gap-1 text-yellow">
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
            </div>
            <p className="text-sm text-[#637381] py-4 max-w-xs">“Después de estudiar en Amura, me sentí preparada para lanzar mi propio negocio. Amura no solo me enseñó técnicas culinarias avanzadas, sino que también me brindó conocimientos sobre gestión y emprendimiento.”</p>
            <div className="flex items-center gap-4 py-4">
              <div className="h-12 w-12 overflow-hidden rounded-full relative">
                <Image src="/images/testimonials/manuella.jpg" alt="Reviewer" width={48} height={48} className="h-12 w-12 object-cover" sizes="48px"/>
              </div>
              <div>
                <p className="font-bold text-sm">Manuella Saenz</p>
                <p className="font-thin text-xs">Emprededora</p>
              </div>
            </div>
          </div>
          <div className="rounded-xl border border-[#FBF0E3] bg-white shadow-lg py-4 px-8 max-w-xs md:max-w-sm">
            <div className="flex gap-1 text-yellow">
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
              <FontAwesomeIcon icon={faStar} />
            </div>
            <p className="text-sm text-[#637381] py-4 max-w-xs">“Como estudiante actual en Amura, puedo decir que cada día es una nueva oportunidad para aprender y crecer. El ambiente es inspirador y los profesores están siempre dispuestos a ayudarnos a mejorar.”</p>
            <div className="flex items-center gap-4 py-4">
              <div className="h-12 w-12 overflow-hidden rounded-full relative">
                <Image src="/images/testimonials/keyron.jpg" alt="Reviewer" width={48} height={48} className="h-12 w-12 object-cover" sizes="48px"/>
              </div>
              <div>
                <p className="font-bold text-sm">Keyron Dávila</p>
                <p className="font-thin text-xs">Estudiante</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}